import React, {PureComponent} from 'react';
import { connect } from 'dva';
import {  Slider, InputNumber} from 'antd';


class FilterPrice extends PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(priceRange){
    const {dispatch} = this.props;

    dispatch({
      type: 'travel/filterPrice',
      range: priceRange
    });

  }

  render() {
    const {min, max, defaultValue} = this.props;

    const marks = {
    [min]:{label: `$${min}`},
    [max]:{label: `$${max}`}
    };

    return(
      <div>
        <label htmlFor="">値段で絞り込み</label>
        <Slider range
                marks={marks}
                min={min}
                max={max}
                defaultValue={defaultValue}
                onChange={this.onChange}  />
      </div>
    )
  }
}

export default connect(({ travel }) => ({
  travel
}))(FilterPrice);



// WEBPACK FOOTER //
// ./src/pages/travel/components/FilterPrice.js